import {
  Button,
  Flex,
  Icon,
  Img,
  ModalBody,
  ModalHeader,
  Text,
} from "@chakra-ui/react";
import { forwardRef } from "react";
import logoMonedd from "../../../../assets/images/logo.png";
import moment from "moment";
import { FaCircle } from "react-icons/fa";

const ModalContentToPrint = forwardRef(({ item }: any, ref: any) => {
  const paymentMethod = item.payment_method || {};
  const paymentAuthorization = item.payment_authorization || {};
  const TransactionHistory =
    item.history && Array.isArray(item.history) ? item.history[0] : {};
  const pointOfSale = item.point_of_sale || {};

  // Verificar condições específicas
  const isContactlessOrChip =
    pointOfSale.entry_mode === "contactless_chip" ||
    pointOfSale.entry_mode === "chip";
  const isSucceeded = item.status === "succeeded";
  const confirmedStatus =
    item.confirmed === "1"
      ? "Sucesso"
      : item.confirmed === "0"
      ? "Pendente"
      : "N/A";

  return (
    <div ref={ref}>
      {item && (
        <ModalBody
          display={"flex"}
          flexDir="column"
          justifyContent={"space-evenly"}
          alignItems="center"
        >
          <Flex
            w={"350px"}
            alignItems={"flex-start"}
            flexDirection="column"
            justifyContent={"space-evenly"}
            px={5}
            shadow={"md"}
            fontSize={"0.8rem"}
            bgColor="#FBFBE2"
          >
            <Img src={logoMonedd} />
            <Text fontWeight="bold" w={"100%"} textAlign="center">
              VIA CLIENTE
            </Text>
            <Text textTransform="uppercase" w={"100%"} textAlign="center">
              {paymentMethod.card_brand || getStatusText(item.payment_type)} -{" "}
              {item.description || ""}
            </Text>
            <Text>-----------------------------------------</Text>
            <Text fontWeight="bold" fontSize={"1.2rem"} my={0.5}>
              {item.statement_descriptor || "Nome do pagador não disponível"}
            </Text>
            <Text my={0.5} mb={4}>
              Valor Bruto:{" "}
              {parseFloat(item.amount).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </Text>
            <Text fontSize={"0.6rem"} my={0.5}>
              Id da transação:{" "}
              {TransactionHistory.transaction || "Número não disponível"}
            </Text>
            <Text fontSize={"0.6rem"} my={0.5}>
              Serial da POS: {pointOfSale.identification_number || "N/A"}
            </Text>
            <Text fontSize={"0.6rem"} my={0.5}>
              Código de Verificação:{" "}
              {paymentAuthorization.authorization_code || "N/A"}
            </Text>
            <Text fontSize={"0.6rem"} my={0.5}>
              Código de Autorização:{" "}
              {paymentAuthorization.authorization_nsu || "N/A"}
            </Text>
            <Text>-----------------------------------------</Text>
            <Text fontWeight={"bold"}>Status da Transação:</Text>
            <Text fontSize={"0.6rem"} my={0.5}>
              <Flex alignItems="center">
                <Icon
                  ml={2}
                  mr={2}
                  as={FaCircle}
                  color={getStatusColor(item.status)}
                />
                {isContactlessOrChip && isSucceeded
                  ? confirmedStatus
                  : getStatusText(item.status)}
              </Flex>
            </Text>
            <Text fontSize={"0.6rem"}>
              N° da Transação: {item.transaction_number || "N/A"}
            </Text>

            <Flex w={"100%"} h={"20px"}></Flex>
            <Flex
              w={"100%"}
              justifyContent={"flex-start"}
              alignItems={"center"}
              mb={"50px"}
            >
              <Text fontWeight={"bold"} marginRight={"25%"}>
                {moment(item.created_at).format("DD/MM/YYYY")} <br />
                {moment(item.created_at).format("HH:mm")}
              </Text>
              <Text fontWeight={"bold"} fontSize={"1.2rem"}>
                <span style={{ fontSize: "0.6rem" }}>Valor:</span>
                <br />
                {parseFloat(item.amount).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Text>
            </Flex>
          </Flex>
        </ModalBody>
      )}
    </div>
  );
});

const getStatusColor = (status: string) => {
  switch (status) {
    case "succeeded":
      return "green";
    case "pending":
      return "yellow";
    case "failed":
      return "orange";
    case "reversed":
      return "pink";
    case "new":
      return "gray";
    case "chargeback":
      return "purple";
    case "canceled":
      return "red";
    default:
      return "black";
  }
};

const getStatusText = (status: string) => {
  switch (status) {
    case "succeeded":
      return "Sucesso";
    case "pending":
      return "Pendente";
    case "failed":
      return "Falhou";
    case "new":
      return "Novo";
    case "chargeback":
      return "ChargeBack";
    case "canceled":
      return "Cancelado";
    case "reversed":
      return "Revertido";
    case "created":
      return "Criado";
    case "disputed":
      return "Disputa";
    default:
      return status || "N/A";
  }
};

export default ModalContentToPrint;
